import { GetQuotesModal } from 'hui';

// Shim module as React.Lazy doesn't work on named exports.
// This should be expanded to include common modal/opus wiring up code.
export default GetQuotesModal;
